import { ControllerProps, FieldValues } from 'react-hook-form'

export type LmRhfProps<TFieldValues extends FieldValues> = Pick<
  ControllerProps<TFieldValues>,
  'defaultValue' | 'control' | 'rules' | 'name'
>
